import { Contact } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateNominationContact: (
  fetchContext: FetchContext,
  contact: Contact,
  accessToken?: string,
) => Promise<void> = (fetchContext, contact, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/contacts/${contact.contactId}`, {
    method: 'PUT',
    body: JSON.stringify(contact),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update nomination contact'));
